import { faPhone, faHistory, faUser } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import moment from "moment";
import { ColumnDescription } from "react-bootstrap-table-next";
import { IComponentModal } from "../../../../Components/Modais/IModalComponent";
import Table from "../../../../Components/Table";
import { ListarContaChatController } from "../../../../Controllers/HelpDesk/GestaoAtendimentos/GestaoAtendimentosControllers";
import useAsyncEffect from "../../../../hooks/useAsyncEffect";
import usePaginationFilter from "../../../../hooks/usePaginationFilter";
import {
    IGestaoAtendimentos,
    IFiltroGestaoContaChatFechado,
} from "../../../../Interfaces/HelpDesk/GestaoAtendimentos/GestaoAtendimentosInterface";
import StorageManagerCapys from "../../../../Tools/Storage";
import InternalError from "../../../Errors/InternalError";
import ModalContaChatHistorico from "../ModalContaChatHistorico";
import AtendimentosFechadosFilter from "./AtendimentosFechadosFiltro";

interface IAtendimentosFechadosProps {
    setShow: (show: boolean) => void;
    setModal: (show: IComponentModal) => void;
}

const filterStorage = new StorageManagerCapys<
    Omit<IFiltroGestaoContaChatFechado, "NR_PAGINA">
>("FILTRO_GESTAO_ATENDIMENTOS_HELPDESK");

export default function AtendimentosFechados(
    props: IAtendimentosFechadosProps
) {
    const { setModal, setShow } = props;
    const { PageFilter, filter, setPage, setPageFilter } =
        usePaginationFilter();

    const {
        value: lstAtendimentos,
        error,
        loading,
    } = useAsyncEffect(async () => {
        const res = await ListarContaChatController({
            ...PageFilter.filter,
            NR_PAGINA: PageFilter.page,
        });

        return res;
    }, [PageFilter]);

    const totalPaginas = lstAtendimentos?.[0]?.NR_PAGINAS || 0;

    //tabela
    const atendimentoColumns: Array<ColumnDescription> = [
        {
            dataField: "ID_CONTA_CHAT",
            text: "",
            formatter: atendimentoRow,
        },
    ];

    function atendimentoRow(cell: any, row: IGestaoAtendimentos) {
        const atendimento = row;
        return (
            <div>
                <div className="card gutter-b card-stretch">
                    <div className="card-body card-header-right ribbon ribbon-clip ribbon-left padding-1x">
                        <div className="ribbon-target" style={{ top: "12px" }}>
                            <span className="ribbon-inner bg-warning"></span>
                            {atendimento.ID_CONTA_CHAT}
                        </div>
                        <div className="d-flex justify-content-between flex-wrap">
                            <div className="flex-grow-1">
                                <div className="d-flex flex-wrap align-items-center">
                                    <div className="d-flex flex-wrap flex-column mt-7">
                                        {atendimento.DS_NOME_CONTATO ? (
                                            <>
                                                <span className="text-muted font-weight-bold text-break">
                                                    {
                                                        atendimento.DS_EMAIL_CONTATO
                                                    }
                                                </span>
                                                <a
                                                    href="#/"
                                                    className="card-title text-hover-primary font-weight-bolder font-size-h3 text-dark mb-1"
                                                >
                                                    {
                                                        atendimento.DS_NOME_CONTATO
                                                    }
                                                </a>
                                            </>
                                        ) : (
                                            <>
                                                <a
                                                    href="#/"
                                                    className="card-title text-hover-primary font-weight-bolder font-size-h3 text-dark mb-1 mt-6"
                                                >
                                                    {atendimento.NR_TELEFONE}
                                                </a>
                                            </>
                                        )}

                                        <div className="mr-6 d-flex flex-wrap">
                                            {atendimento.NR_CPF ? (
                                                <span className="label label-light-info label-inline mr-2 my-1">
                                                    CPF-{atendimento.NR_CPF}
                                                </span>
                                            ) : (
                                                <></>
                                            )}
                                            <span className="label label-light-dark label-inline mr-2 my-1">
                                                <FontAwesomeIcon
                                                    icon={faPhone}
                                                    className="mr-1"
                                                />
                                                {atendimento.NR_TELEFONE}
                                            </span>
                                        </div>
                                    </div>
                                </div>

                                <div className="d-flex flex-wrap">
                                    <div className="d-flex flex-wrap mb-2 mt-2">
                                        <div className="d-flex flex-wrap flex-column mb-2">
                                            <span className="d-block font-weight-bold mb-1">
                                                Data inicio
                                            </span>
                                            <span className="label label-light-primary label-inline mr-2 my-1">
                                                {moment(
                                                    atendimento.DT_INICIO_CHAT
                                                ).format("lll")}
                                            </span>
                                        </div>
                                        {atendimento.DT_FIM_CHAT && (
                                            <div className="d-flex flex-wrap flex-column">
                                                <span className="d-block font-weight-bold mb-1">
                                                    Data Final
                                                </span>
                                                <span className="label label-light-success label-inline mr-2 my-1">
                                                    {moment(
                                                        atendimento.DT_FIM_CHAT
                                                    ).format("lll")}
                                                </span>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>

                            <div className="flex-grow-1 d-flex justify-content-end p-4 g-2">
                                <div className="">
                                    <h6 className="text-right">
                                        Atendente
                                        {row.ATENDENTES.length > 1 ? "s" : ""}
                                    </h6>
                                    <span className="d-flex flex-wrap justify-content-end g-2">
                                        {row.ATENDENTES.map((a) => (
                                            <div
                                                key={a.ID_USUARIO}
                                                className="d-flex align-items-center g-2 p-2 label label-lg label-inline"
                                            >
                                                <FontAwesomeIcon
                                                    icon={faUser}
                                                />
                                                {a.DS_NOME}
                                            </div>
                                        ))}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="card-footer d-flex align-items-center flex-wrap">
                        <div className="d-flex">
                            <div className="d-flex align-items-center">
                                <span className="svg-icon svg-icon-gray-500">
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="24px"
                                        height="24px"
                                        viewBox="0 0 24 24"
                                        version="1.1"
                                    >
                                        <g
                                            stroke="none"
                                            strokeWidth="1"
                                            fill="none"
                                            fillRule="evenodd"
                                        >
                                            <rect
                                                x="0"
                                                y="0"
                                                width="24"
                                                height="24"
                                            ></rect>
                                            <path
                                                d="M16,15.6315789 L16,12 C16,10.3431458 14.6568542,9 13,9 L6.16183229,9 L6.16183229,5.52631579 C6.16183229,4.13107011 7.29290239,3 8.68814808,3 L20.4776218,3 C21.8728674,3 23.0039375,4.13107011 23.0039375,5.52631579 L23.0039375,13.1052632 L23.0206157,17.786793 C23.0215995,18.0629336 22.7985408,18.2875874 22.5224001,18.2885711 C22.3891754,18.2890457 22.2612702,18.2363324 22.1670655,18.1421277 L19.6565168,15.6315789 L16,15.6315789 Z"
                                                fill="#000000"
                                            ></path>
                                            <path
                                                d="M1.98505595,18 L1.98505595,13 C1.98505595,11.8954305 2.88048645,11 3.98505595,11 L11.9850559,11 C13.0896254,11 13.9850559,11.8954305 13.9850559,13 L13.9850559,18 C13.9850559,19.1045695 13.0896254,20 11.9850559,20 L4.10078614,20 L2.85693427,21.1905292 C2.65744295,21.3814685 2.34093638,21.3745358 2.14999706,21.1750444 C2.06092565,21.0819836 2.01120804,20.958136 2.01120804,20.8293182 L2.01120804,18.32426 C1.99400175,18.2187196 1.98505595,18.1104045 1.98505595,18 Z M6.5,14 C6.22385763,14 6,14.2238576 6,14.5 C6,14.7761424 6.22385763,15 6.5,15 L11.5,15 C11.7761424,15 12,14.7761424 12,14.5 C12,14.2238576 11.7761424,14 11.5,14 L6.5,14 Z M9.5,16 C9.22385763,16 9,16.2238576 9,16.5 C9,16.7761424 9.22385763,17 9.5,17 L11.5,17 C11.7761424,17 12,16.7761424 12,16.5 C12,16.2238576 11.7761424,16 11.5,16 L9.5,16 Z"
                                                fill="#000000"
                                                opacity="0.3"
                                            ></path>
                                        </g>
                                    </svg>
                                </span>
                                <span
                                    className="font-weight-bolder text-primary ml-2"
                                    role="button"
                                    onClick={() => {
                                        setModal({
                                            Component: () =>
                                                ModalContaChatHistorico(
                                                    row.ID_CONTA_CHAT
                                                ),
                                            headerComponent: "Histórico",
                                            IconHeader: faHistory,
                                            size: "lg",
                                            customBodyClasses:
                                                "customScroll modal-controlled-heigth",
                                        });
                                        setShow(true);
                                    }}
                                >
                                    Historico do Caso
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    if (error) return <InternalError />;

    return (
        <>
            <AtendimentosFechadosFilter
                handleSubmit={(formData) => {
                    setPageFilter({
                        filter: formData,
                        page: 1,
                    });
                }}
                defaultFilter={filter}
                storageManager={filterStorage}
            />
            <Table
                columns={atendimentoColumns}
                data={lstAtendimentos ?? []}
                keyField="ID_CONTA_CHAT"
                loading={loading}
                onTableChange={(type, newState) => {
                    setPage(newState.page);
                }}
                remote={{ pagination: true }}
                totalPages={totalPaginas}
                noDataIndication={() => (
                    <div className="text-black-50 text-center">
                        Nenhum Atendimento encontrado
                    </div>
                )}
                noHover
                bordered={false}
                noSearch
            />
        </>
    );
}
